import React from 'react';
export function Footer() {
  return <footer className="bg-[#2D3B2D] text-white py-12 px-6" data-id="element-49">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-50">
        <div className="font-serif font-bold text-xl text-wellness-white" data-id="element-51">
          Reset de Hinchazón
        </div>

        <div className="text-wellness-white/70 text-sm" data-id="element-52">
          Reset de Hinchazón en 7 Días © 2026
        </div>

        <div className="flex gap-6 text-sm text-wellness-white/80" data-id="element-53">
          <a href="#" className="hover:text-wellness-gold transition-colors" data-id="element-54">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-wellness-gold transition-colors" data-id="element-55">
            Términos
          </a>
          <a href="#" className="hover:text-wellness-gold transition-colors" data-id="element-56">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}